let $dropzone;
let subCategoriaActiva = 0;
var editor = [];
var selectedFiles = [];
let reconstruirConFileGen = 0;
let estadoActual = 0;
let ciudadActual = 0;
let otroTipo = '';
let otroNombreSugerido = '';
let imageChange = false;
let estoyAquiClicked = false;
let pagina = 1;
let acumulados = 0;
$( document ).ready( function() {
    syncMobileButtonA11y();
    if ( checaSesion( 'usuarioId' ) && $( 'nav.account' ).length == 0 ) { limpiaSesion(); }
    if ( window.matchMedia ) {
        var mqMobileMenu = window.matchMedia( '(max-width: 1125px)' );
        if ( typeof mqMobileMenu.addEventListener === 'function' ) {
            mqMobileMenu.addEventListener( 'change', syncMobileButtonA11y );
        } else if ( typeof mqMobileMenu.addListener === 'function' ) {
            mqMobileMenu.addListener( syncMobileButtonA11y );
        }
    }
    $( '.mobileButton' ).click( function() {
        var $menu = $( 'nav.mainMenu' );
        var cerrando = $menu.is( ':visible' );
        if ( cerrando ) {
            resetMobileMenuButtonUI();
        } else {
            $( this ).find( 'i' ).removeClass( 'fa-bars' );
            $( this ).find( 'i' ).addClass( 'fa-close' );
            let txt = idioma == 'ES' ? 'Cerrar' : 'Close';
            $( this ).find( 'span' ).html( txt );
        }
        $menu.slideToggle( function() {
            if ( !cerrando && $menu.is( ':visible' ) ) {
                var $primer = $menu.find( 'a' ).filter( ':visible' ).first();
                if ( $primer.length ) {
                    $primer.trigger( 'focus' );
                }
            }
        } );
    } );
    $( 'nav.mainMenu' ).on( 'focusout', function() {
        if ( !window.matchMedia || !window.matchMedia( '(max-width: 1125px)' ).matches ) {
            return;
        }
        var $btn = $( '.mobileButton' );
        if ( !$btn.length || !$btn.is( ':visible' ) ) {
            return;
        }
        var $menu = $( 'nav.mainMenu' );
        var menuEl = $menu[ 0 ];
        setTimeout( function() {
            if ( !$menu.is( ':visible' ) ) {
                return;
            }
            var active = document.activeElement;
            if ( active && menuEl.contains( active ) ) {
                return;
            }
            $menu.slideUp();
            resetMobileMenuButtonUI();
        }, 0 );
    } );
    $( 'button.currentLang' ).on( 'click', function() {
        $( this ).parent().toggleClass( 'open' );
    } );
    $( '.langMenu').on( 'focusout', function(e) {
        if (!$(this).has(e.relatedTarget).length) {
            $(this).find('.open').removeClass('open');
        }
    } );
	$( document ).tooltip( {
        items: '[data-tooltip]',
		content: function () {  return $( this ).data('tooltip'); },
		track: false,
		position: {
			my: "center bottom-10",
			at: "center top",
			collision: "flipfit"
		},
        create: function( event, ui ) {
            $( event.target ).removeAttr( 'aria-describedby' );
            $( ui.tooltip ).attr( 'aria-hidden', 'true' ).attr( 'role', 'presentation' );
        },
        open: function( event, ui ) {
            $( event.target ).removeAttr( 'aria-describedby' );
            $( ui.tooltip ).attr( 'aria-hidden', 'true' ).attr( 'role', 'presentation' );
        }
	} );
	if ( $( '.tabs' ).length > 0 ) {
		$( '.tabs li a' ).on( 'click', function() {
            $( '.tab-pane, .tabs li' ).removeClass( 'active' );
            $( this ).parent().addClass( 'active' );
            let panelId = $( this ).attr( 'aria-controls' );
            if ( $( '#' + panelId ).is( ':hidden' ) ) {
               $( '#' + panelId ).addClass( 'active' );
            }
        } );
	}
    if ( $( '#loginForm' ).length > 0 ) {
        $( '#loginForm' ).submit( function( e ) {
            e.preventDefault();
            if ( validaForm( 'loginForm' ) ) {
                if ( $( '#loginForm .button' ).hasClass( 'skeleton' ) ) { return false; }
                $( '#loginForm .button' ).addClass( 'skeleton' );
                ajaxRequest( false, 'POST', { 'email': $( '#emailLogin' ).val(), 'pass': $( '#passwordLogin' ).val() }, 'api/account/login', iniciaSesion );
            }
        } );
		$( '#registroForm' ).submit( function( e ) {
            e.preventDefault();
            if ( validaForm( 'registroForm' ) ) {
                if ( $( '#registroForm .button' ).hasClass( 'skeleton' ) ) { return false; }
                if ( $( '#passwordRegistro' ).val() == $( '#confirmPasswordRegistro' ).val() ) {
                    $( '#registroForm .button' ).addClass( 'skeleton' );
                    var parametros = {
                        'email': $( '#emailRegistro' ).val(),
                        'pass': $( '#passwordRegistro' ).val(),
                        'nombre': $( '#nombreRegistro' ).val(),
                        'rolId': $( 'input[name="tipoCuenta"]:checked' ).val()
                    };
                    ajaxRequest( false, 'POST', parametros, 'api/account/registro', registraSesion );
                } else {
                    let msg = idioma == 'ES' ? 'Las contraseñas no coinciden' : 'Passwords do not match';
                    alerta( msg, 'error', false );
                }
            }
        } );
    }
    if ( $( '#newsletterForm' ).length > 0 ) {
        $( '#newsletterForm' ).submit( function( e ) {
            e.preventDefault();
            if ( validaForm( 'newsletterForm' ) ) {
                suscripbeForm();
            }
        } );
    }
    if ( $( '#placeForm' ).length > 0 ) {
        $( '.accordion-trigger' ).on( 'click', function() {
            $( this ).attr( 'aria-expanded', function( i, attr ) {
                return attr === 'true' ? 'false' : 'true';
            } );
            $( this ).find( 'i' ).toggleClass( 'fa-chevron-right fa-chevron-down' );
            let panelId = $( this ).attr( 'aria-controls' );
            if ( $( '#' + panelId ).is( ':hidden' ) ) {
               $( '#' + panelId ).removeAttr( 'hidden' );
            } else {
                $( '#' + panelId ).attr( 'hidden', true );
            }
        } );
        $( '.featureItem' ).on( 'click', function() {
            let inputCheck = $( this ).find( 'input[type="checkbox"]' );
            if ( inputCheck.is( ':checked' ) ) {
                inputCheck.prop( 'checked', false );
                $( this ).removeClass( 'checked' );
            } else {
                inputCheck.prop( 'checked', true );
                $( this ).addClass( 'checked' );
            }
            announceFeatureToggle( $( this ) );
        } );
        $( '#placeForm' ).submit( function( e ) {
            e.preventDefault();
            e.stopPropagation();
            if ( validaForm( 'placeForm' ) ) {
                guardaFormulario( 'placeForm' );
            }
        } );
        selectedFiles = [];
        $dropzone = $( '#dropzone' );
        $( document ).on( 'dragover drop', function( e ) {
            e.preventDefault();
        } );
        $dropzone.on( 'dragenter', function( e ) {
            e.preventDefault();
            e.stopPropagation();
            setDropActive( true );
        } );
        $dropzone.on( 'dragover', function( e ) {
            e.preventDefault();
            e.stopPropagation();
            setDropActive( true );
        } );
        $dropzone.on( 'dragleave', function( e ) {
            e.preventDefault();
            e.stopPropagation();
            if ( e.target === this ) { setDropActive( false ); }
        } );
        $dropzone.on( 'drop', function( e ) {
            e.preventDefault();
            e.stopPropagation();
            setDropActive( false );
            const dt = e.originalEvent && e.originalEvent.dataTransfer;
            if ( !dt || !dt.files || dt.files.length === 0 ) return;
            const allowedExts = new Set( ['png','jpg','gif','jpeg','svg','webp','jfif'] );
            const files = Array.from( dt.files ).filter( f => allowedExts.has( f.name.split('.').pop().toLowerCase() ) );
            if ( files.length === 0 ) return;
            cargaImagenesDesdeFiles( files );
        } );
        iniciaLocaciones( 1 );
    }
    if ( $( '#buscaHome' ).length > 0 ) {
        $( '#buscaHome' ).submit( function( e ) {
            e.preventDefault();
            if ( validaForm( 'buscaHome' ) ) {
                busquedaHome();
            }
        } );
        iniciaLocaciones( 2 );
    }
    if ( archivoUsado == 'agregar-lugar.php' ) {
        tablaActual = 'places';
		if ( checaSesion( 'usuarioId' ) ) { $( '#usuarioId' ).val( obtenSesion( 'usuarioId' ) ); }
        //navigator.geolocation.getCurrentPosition( cargaCoordenadas, function() { console.log( 'error obteniendo coordenadas' ); } );
    } else if ( archivoUsado == 'lugar-detalle.php' ) {
        $( '#valoracionForm' ).submit( function( e ) {
            e.preventDefault();
            if ( checaSesion( 'usuarioId' ) ) {
                if ( validaForm( 'valoracionForm' ) ) {
                    var parametros = {
                        'valoracionId': 0,
                        'placeId': $( '#placeId' ).val(),
                        'usuarioId': obtenSesion( 'usuarioId' ),
                        'puntuacion': $( '#puntuacion' ).val(),
                        'comentario': $( '#comentario' ).val()
                    };
                    ajaxRequest( true, 'POST', parametros, 'api/controller/add/valoracion', lugarEvaluado );
                }
            } else {
                let msg = idioma == 'ES' ? 'Debes iniciar sesión para enviar una reseña' : 'You must log in to submit a review';
                alerta( msg, 'error', false );
            }
        } );
        cargaFeatures();
        $( '#valoracionForm .starPick' ).on( 'click', function( e ) {
            e.preventDefault();
            let v = $( this ).data( 'value' );
            $( '#puntuacion' ).val( v ).trigger( 'change' );
            $( '#valoracionForm .starPick' ).each( function() {
                let cur = $( this ).data( 'value' );
                $( this ).toggleClass( 'is-active', cur <= v );
            } );
            let msg = idioma == 'ES' ? v + ' de 5 seleccionados' : v + ' out of 5 selected';
            alerta( msg, 'success', false );
        } );
        $( '.accordion-trigger' ).on( 'click', function() {
            $( this ).attr( 'aria-expanded', function( i, attr ) {
                return attr === 'true' ? 'false' : 'true';
            } );
            $( this ).find( 'i' ).toggleClass( 'fa-chevron-right fa-chevron-down' );
            let panelId = $( this ).attr( 'aria-controls' );
            if ( $( '#' + panelId ).is( ':hidden' ) ) {
               $( '#' + panelId ).removeAttr( 'hidden' );
            } else {
                $( '#' + panelId ).attr( 'hidden', true );
            }
        } );
        $( '.featureItem' ).on( 'click', function() {
            let inputCheck = $( this ).find( 'input[type="checkbox"]' );
            if ( inputCheck.is( ':checked' ) ) {
                inputCheck.prop( 'checked', false );
                $( this ).removeClass( 'checked' );
            } else {
                inputCheck.prop( 'checked', true );
                $( this ).addClass( 'checked' );
            }
            announceFeatureToggle( $( this ) );
        } );
        $( '#featuresForm' ).submit( function( e ) {
            e.preventDefault();
            e.stopPropagation();
            if ( validaForm( 'featuresForm' ) ) {
                guardaFeatures();
            }
        } );
        $( '.mainImage > img' ).attr( 'id', 'changeImage' );
    } else if ( archivoUsado == 'general.php' ) {
        $( '#generalForm' ).submit( function( e ) {
			e.preventDefault();
            e.stopPropagation();
            if ( validaForm( 'generalForm' ) ) {
			    guardaFormulario( 'generalForm' );
            }
		} );
        readIconList();
        if ( $( '.htmlEditor' ).length ) {
			document.querySelectorAll( '.htmlEditor' ).forEach( ( element, index ) => {
				ClassicEditor.create( element, {
					toolbar: {
						items: [ 'heading', '|', 'bold', 'italic', '|', 'undo', 'redo' , '|', 'alignment', 'link', '|', 'bulletedList', 'numberedList', 'todoList' ]
					}
				} ).then( newEditor => { editor[element.id] = newEditor; console.log( element.id ); } );
			} );
		}
        if ( $( '.color' ).length ) {
            $( '.color' ).spectrum( {
                color: '#D4148E',
                showInput: true,
                preferredFormat: "hex",
            } );
        }
        if ( datoId == 0 ) { traeGeneral(); }
		else { elegido( datoId ); }
        if ( $( '.ordenable' ).length ) {
            $( 'tbody.ordenable' ).sortable( {
                handle: '.arrastrable', 
                helper: function (e, tr) {
                    var $originals = tr.children();
                    var $helper = tr.clone();
                    $helper.children().each(function (index) {
                        $(this).width($originals.eq(index).width());
                    });
                    return $helper;
                },
                stop: function (event, ui) {
                    $( this ).children().each( function( index ) {
                        $( this ).find( 'td' ).last().html( index + 1 );
                    } );
                    actualizaPosiciones();
                },
            } ).disableSelection();
        }
    } else if ( archivoUsado == 'auth.php' ) {
		const firebaseConfig = {
			apiKey: "AIzaSyDRXXgw33-g4qiraQrcy7zVNaBztwkKuT0",
			authDomain: "lugares-accesibles.firebaseapp.com",
			databaseURL: "https://lugares-accesibles.firebaseio.com",
			projectId: "lugares-accesibles",
			storageBucket: "lugares-accesibles.firebasestorage.app",
			messagingSenderId: "208320962604",
			appId: "1:208320962604:web:61afde3711c1af12"
		};
		firebase.initializeApp( firebaseConfig );
		const auth = firebase.auth();
	} else if ( archivoUsado == 'validar-negocio.php' ) {
        tablaActual = 'negocios';
        $( 'div[contiene="usuarioId"]' ).hide();
        $( 'div[contiene="statusId"]' ).hide();
        $( '#statusId' ).val( 2 );
        if ( checaSesion( 'usuarioId' ) ) { $( '#usuarioId' ).val( obtenSesion( 'usuarioId' ) ); }
        $( '#generalForm' ).submit( function( e ) {
			e.preventDefault();
            e.stopPropagation();
            if ( validaForm( 'generalForm' ) ) {
                if ( checaSesion( 'usuarioId' ) ) {
                    guardaFormulario( 'generalForm' );
                } else {
                    let msg = idioma == 'ES' ? 'Debes iniciar sesión para enviar una solicitud' : 'You must log in to submit a request';
                    alerta( msg, 'error', false );
                }
            }
		} );
    } else if ( archivoUsado == 'buscar.php' ) {
        $( '.accordion-trigger' ).on( 'click', function() {
            $( this ).attr( 'aria-expanded', function( i, attr ) {
                return attr === 'true' ? 'false' : 'true';
            } );
            $( this ).find( 'i' ).toggleClass( 'fa-chevron-right fa-chevron-down' );
            let panelId = $( this ).attr( 'aria-controls' );
            if ( $( '#' + panelId ).is( ':hidden' ) ) {
               $( '#' + panelId ).removeAttr( 'hidden' );
            } else {
                $( '#' + panelId ).attr( 'hidden', true );
            }
            setTimeout( function() {
                if ( typeof redimensionaMapaBusqueda === 'function' ) {
                    redimensionaMapaBusqueda();
                }
            }, 50 );
        } );
        $( '#busquedaForm' ).submit( function( e ) {
			e.preventDefault();
            if ( $( '#busquedaForm .button[type="submit"]' ).hasClass( 'skeleton' ) ) { return false; }
            $( '#busquedaForm .button[type="submit"]' ).addClass( 'skeleton' );
			realizaBusqueda();
		} );
        iniciaLocaciones( 1 );
        if ( checaSesion( 'busquedaGeneral' ) || checaSesion( 'busquedaPaisId' ) ) {
            if ( checaSesion( 'busquedaGeneral' ) ) { $( '#buscaInput' ).val( obtenSesion( 'busquedaGeneral' ) ); }
            if ( checaSesion( 'busquedaPaisId' ) ) { $( '#paisId' ).val( obtenSesion( 'busquedaPaisId' ) ).trigger( 'change' ); }
            borraSesion( 'busquedaGeneral' );
            borraSesion( 'busquedaPaisId' );
            if ( !checaSesion( 'busquedaEstadoId' )  && !checaSesion( 'busquedaCiudadId' ) ) {
                realizaBusqueda();
            }
        }
        $( '.moreFiltersLink' ).on( 'click', function() {
            if ($( '#containerFilters' ).is( ':hidden' ) ) {
                let text = idioma == 'ES' ? 'Ocultar filtros de accesibilidad' : 'Hide accessibility filters';
                $( this ).html( '<i class="fas fa-chevron-up" aria-hidden="true"></i> ' + text );
            } else {
                let text = idioma == 'ES' ? 'Ver más filtros de accesibilidad' : 'Show more accessibility filters';
                $( this ).html( '<i class="fas fa-chevron-down" aria-hidden="true"></i> ' + text );
            }
            $( '#containerFilters' ).slideToggle( 400, function() {
                if ( typeof redimensionaMapaBusqueda === 'function' ) {
                    redimensionaMapaBusqueda();
                }
            } );
        } );
        if ( typeof ResizeObserver !== 'undefined' && document.querySelector( 'aside.filtros' ) ) {
            var filtrosObserver = new ResizeObserver( function() {
                if ( typeof redimensionaMapaBusqueda === 'function' ) {
                    redimensionaMapaBusqueda();
                }
            } );
            filtrosObserver.observe( document.querySelector( 'aside.filtros' ) );
        }
        setTimeout( function() {
            if ( typeof redimensionaMapaBusqueda === 'function' ) {
                redimensionaMapaBusqueda();
            }
        }, 200 );
        navigator.geolocation.getCurrentPosition( coordenadasBusqueda, function() {
            console.log( 'sin permiso de busqueda' );
        } );
        $( window ).on( 'resize', function() {
            if ( typeof redimensionaMapaBusqueda === 'function' ) {
                redimensionaMapaBusqueda();
            }
        } );
    } else if ( archivoUsado == 'sugerir-categoria.php' ) {
        tablaActual = 'categoria';
        $( '#categoryForm' ).submit( function( e ) {
            e.preventDefault();
            e.stopPropagation();
            if ( validaForm( 'categoryForm' ) ) {
                guardaFormulario( 'categoryForm' );
            }
        } );
    } else if ( archivoUsado == 'ser-validador.php' ) {
        $( '.modalLink' ).on( 'click', function( e ) {
            e.preventDefault();
            console.log( 'clic' );
            popup( 'validadorModal', true );
        } );
    } else if ( archivoUsado == 'contacto.php' ) {
        $( '#contactoForm' ).submit( function( e ) {
            e.preventDefault();
            if ( validaForm( 'contactoForm' ) ) {
                contactoMail();
            }
        } );
    } else if ( archivoUsado == 'sugerencias.php' ) {
        sugerenciasUbicaciones();
    }
	if ( $( '.swiper' ).length ) {
		new Swiper( '.swiper', {
			slidesPerView: 1,
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				enabled: true
			},
			allowTouchMove: true,
			loop: true,
			navigation: false,
			centeredSlides: true,
			pagination: false
		} );
	}
	if ( unicoData == 1 && datoId != 0 ) {
		$( 'div[contiene="rolId"]' ).hide();
	}
} );
function iniciaLocaciones( ubicacion ) {
    console.log( 'iniciando locaciones' );
    let paisSelect = ubicacion == 1 ? '#paisId' : '#busquedaPaisId';
    let estadoSelect = ubicacion == 1 ? '#estadoId' : '#busquedaEstadoId';
    let ciudadSelect = ubicacion == 1 ? '#ciudadId' : '#busquedaCiudadId';
    $( paisSelect ).off( 'change' ).on( 'change', function( e ) {
        e.preventDefault();
        if ( $( this ).val() != null && $( this ).val().trim() != '' && $( this ).val().trim() != 0 ) {
            if ( $( this ).val() != '-1' ) {
                var parametros = {
                    'filtra': [
                        {
                            'campo': 'paisId',
                            'valor': $( this ).val(),
                            'tipo': 'int',
                            'asignacion': '='
                        },
                        {
                            'campo': 'activo',
                            'valor': 'S',
                            'tipo': 'string',
                            'asignacion': '='
                        }
                    ]
                };
                $( estadoSelect ).val( '' ).trigger( 'change' );
                $( ciudadSelect ).val( '' ).trigger( 'change' );
                $( estadoSelect ).next('.select2-container').addClass( 'skeleton' );
                ajaxRequest( false, 'POST', parametros, 'api/controller/list/estados', optionEstados );
            } else {
                otroDato( 1 );
            }
        } else {
            var estadoHtml = idioma == 'ES' ? '<option value="">Elige primero un país</option>' : '<option value="">Select a country first</option>';
            $( estadoSelect ).html( estadoHtml );
            $( estadoSelect ).val( '' ).trigger( 'change' );
            var ciudadHtml = idioma == 'ES' ? '<option value="">Elige primero un estado</option>' : '<option value="">Select a state first</option>';
            $( ciudadSelect ).html( ciudadHtml );
            $( ciudadSelect ).val( '' ).trigger( 'change' );
        }
    } );
    $( estadoSelect ).off( 'change' ).on( 'change', function( e ) {
        e.preventDefault();
        if ( $( this ).val() != '' && $( this ).val() != null && $( this ).val() != 0 ) {
            if ( $( this ).val() != '-1' ) {
                var parametros = {
                    'filtra': [
                        {
                            'campo': 'estadoId',
                            'valor': $( this ).val(),
                            'tipo': 'int',
                            'asignacion': '='
                        },
                        {
                            'campo': 'activo',
                            'valor': 'S',
                            'tipo': 'string',
                            'asignacion': '='
                        }
                    ]
                };
                $( ciudadSelect ).val( '' ).trigger( 'change' );
                $( ciudadSelect ).next('.select2-container').addClass( 'skeleton' );
                ajaxRequest( false, 'POST', parametros, 'api/controller/list/ciudades', optionCiudades );
            } else {
                otroDato( 2 );
            }
        } else {
            var ciudadHtml = idioma == 'ES' ? '<option value="">Elige primero un estado</option>' : '<option value="">Select a state first</option>';
            $( ciudadSelect ).html( ciudadHtml );
            $( ciudadSelect ).val( '' ).trigger( 'change' );
        }
    } );
    $( ciudadSelect ).off( 'change' ).on( 'change', function( e ) {
        e.preventDefault();
        if ( $( this ).val() == '-1' ) {
            otroDato( 3 );
        }
    } );
    if ( ubicacion == 1 ) {
        cargaSugerencias();
    }
    $( '.select2' ).select2();
}
function cargaSugerencias() {
    let sugerirNuevo = idioma == 'ES' ? 'Sugerir nuevo' : 'Suggest new';
    let opcionHtml = '<option value="-1">' + sugerirNuevo + '</option>';
    [ '#paisId', '#estadoId', '#ciudadId' ].forEach( function( selector ) {
        var $sel = $( selector );
        if ( !$sel.length ) {
            return;
        }
        if ( !$sel.find( 'option[value="-1"]' ).length ) {
            $sel.append( opcionHtml );
        }
    } );
}
function reiniciaLocaciones( ubicacion ) {
    estadoActual = 0;
    ciudadActual = 0;
    let paisSelect = ubicacion == 1 ? '#paisId' : '#busquedaPaisId';
    let estadoSelect = ubicacion == 1 ? '#estadoId' : '#busquedaEstadoId';
    let ciudadSelect = ubicacion == 1 ? '#ciudadId' : '#busquedaCiudadId';
    $( paisSelect ).val( '' ).trigger( 'change' );
    var estadoHtml = idioma == 'ES' ? '<option value="">Elige primero un país</option>' : '<option value="">Select a country first</option>';
    $( estadoSelect ).html( estadoHtml );
    $( estadoSelect ).val( '' ).trigger( 'change' );
    var ciudadHtml = idioma == 'ES' ? '<option value="">Elige primero un estado</option>' : '<option value="">Select a state first</option>';
    $( ciudadSelect ).html( ciudadHtml );
    $( ciudadSelect ).val( '' ).trigger( 'change' );
}
function syncMobileButtonA11y() {
    var $btn = $( '.mobileButton' );
    if ( !$btn.length ) {
        return;
    }
    if ( window.matchMedia( '(max-width: 1125px)' ).matches ) {
        $btn.attr( 'aria-hidden', 'false' );
        $btn.removeAttr( 'tabindex' );
    } else {
        $btn.attr( 'aria-hidden', 'true' );
        $btn.attr( 'tabindex', '-1' );
    }
}
function resetMobileMenuButtonUI() {
    var $btn = $( '.mobileButton' );
    if ( !$btn.length ) {
        return;
    }
    $btn.find( 'i' ).addClass( 'fa-bars' ).removeClass( 'fa-close' );
    $btn.find( 'span' ).html( idioma == 'ES' ? 'Menú' : 'Menu' );
}
function announceFeatureToggle( $item ) {
    let inputCheck = $item.find( 'input[type="checkbox"]' );
    let annId = 'feature-ann-' + inputCheck.attr( 'id' );
    let $live = $( '#' + annId );
    if ( !$live.length ) {
        return;
    }
    let shortname = $item.find( 'label' ).first().text().trim();
    let onMsg = $item.data( 'announceSelected' );
    let offMsg = $item.data( 'announceUnselected' );
    let msg = inputCheck.is( ':checked' ) ? shortname + ', ' + onMsg : shortname + ', ' + offMsg;
    $live.text( '' );
    if ( $live[ 0 ] ) {
        void $live[ 0 ].offsetWidth;
    }
    $live.text( msg );
}
function setDropActive( active ) {
    $dropzone.toggleClass( 'is-over', !!active );
}
function cargaSubcategorias( categoriaId ) {
    $( 'div[data-contiene="subcategoriaId"]' ).attr( 'hidden', true );
    $( 'div[data-contiene="nuevaCategoria"]' ).attr( 'hidden', true );
    $( '#subcategoriaId' ).attr( 'required', false );
    var parametros = {
		'filtra': [
            {
                'campo': 'categoriaId',
                'valor': categoriaId,
                'tipo': 'int',
                'asignacion': '='
		    },
            {
                'campo': 'activo',
                'valor': 'S',
                'tipo': 'string',
                'asignacion': '='
		    }
        ]
	};
	ajaxRequest( false, 'POST', parametros, 'api/controller/list/subcategoria', listaSubcategorias );
}
function listaSubcategorias( respuesta ) {
    var datos = JSON.parse( respuesta );
	if ( datos.status == 'Success' ) {
        var html = idioma == 'ES' ? '<option value="">Selecciona una subcategoría</option>' : '<option value="">Select a subcategory</option>';
        $.each( datos.datos, function( index, info ) {
            var nombreField = idioma == 'ES' ? info.name : ( info.name_en != null && info.name_en != '' ? info.name_en : info.name );
            html += '<option value="' + info.subcategoriaId + '">' + nombreField + '</option>';
        } );
        $( '#subcategoriaId' ).html( html );
        $( '#subcategoriaId' ).attr( 'required', true );
        $( 'div[data-contiene="subcategoriaId"]' ).attr( 'hidden', false );
        if ( subCategoriaActiva != 0 ) { $( '#subcategoriaId' ).val( subCategoriaActiva ).trigger( 'change' ); }
    }
}
function estoyAqui() {
    estoyAquiClicked = true;
    navigator.geolocation.getCurrentPosition( cargaCoordenadas, function() {
        let msg = idioma == 'ES' ? 'No cuenta con el permiso de ubicación activado' : 'Location permission is not enabled';
        alerta( msg, 'info', false );
    } );
}
function cargaCoordenadas( position ) {
    seteaSesion( 'latitud', position.coords.latitude );
    seteaSesion( 'longitud', position.coords.longitude );
    $( '#latitude' ).val( obtenSesion( 'latitud' ) );
    $( '#longitude' ).val( obtenSesion( 'longitud' ) );
    if ( estoyAquiClicked ) { direccionSugerida(); }
    estoyAquiClicked = false;
}
function parametrosGeocode( r ) {
    var comps = [];
    console.log( r );
    var pais = '', estado = '', ciudad = '', postalCode = '';
    $.each( r.address_components || [], function( _, ac ) {
        var plain = { long_name: ac.long_name, short_name: ac.short_name, types: ac.types ? ac.types.slice() : [] };
        comps.push( plain );
        $.each( plain.types, function( __, t ) {
            if ( t === 'country' ) { pais = plain.long_name; }
            if ( t === 'administrative_area_level_1' ) { estado = plain.long_name; }
            if ( t === 'locality' ) { ciudad = plain.long_name; }
            if ( t === 'postal_code' ) { postalCode = plain.long_name; }
        } );
    } );
    if ( !ciudad ) {
        $.each( comps, function( _, c ) {
            $.each( c.types, function( __, t ) {
                if ( t === 'sublocality_level_1' || t === 'administrative_area_level_2' ) { ciudad = c.long_name; }
            } );
        } );
    }
    return {
        pais: pais,
        estado: estado,
        ciudad: ciudad,
        postalCode: postalCode
    };
}
function direccionSugerida() {
    var latLong = new google.maps.LatLng( obtenSesion( 'latitud' ), obtenSesion( 'longitud' ) );
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode(
        { 'latLng': latLong },
        function( results, status ) {
            if ( status == google.maps.GeocoderStatus.OK ) {
                if ( results[0] ) {
                    var addressData = results[0];
                    direccion = addressData.formatted_address;
                    $( '#address' ).val( direccion );
                    var parametros = parametrosGeocode( addressData );
                    $( '#postal_code' ).val( parametros.postalCode );
                    ajaxRequest( false, 'POST', parametros, 'api/lugar/sugerencia-geocode', setearDireccion );
                }
            }
        }
    );
}
function setearDireccion( respuesta ) {
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        if ( datos.estado != 0 ) { estadoActual = datos.estado; }
        if ( datos.ciudad != 0 ) { ciudadActual = datos.ciudad; }
        if ( datos.pais != 0 ) { $( '#paisId' ).val( datos.pais ).trigger( 'change' ); }
    }
}
function cargaImagenesDesdeFiles( files ) {
    imageChange = true;
	$.each( files, function( key, value ) {
		selectedFiles.push( { 'key': key, 'file': value, 'url': URL.createObjectURL( value ), 'principal': false } );
	} );
    cargaFileList();
}
function cargaImagenes() {
    $( '#placeImages' ).each( function() {
		var files = $( this ).prop( 'files' );
		cargaImagenesDesdeFiles( files )
	} );
}
function cargaFileList() {
    let li = '';
    $( '#fileList' ).html( '' );
    let principalTxt = idioma == 'ES' ? 'Principal' : 'Main';
	$.each( selectedFiles, function( index, item ) {
        let imgTxt = index + 1;
        let mainTxt = idioma == 'ES' ? 'Marcar la imagen ' + imgTxt + ' como principal' : 'Mark the image ' + imgTxt + ' as main image';
        let deleteTxt = idioma == 'ES' ? 'Borrar la imagen ' + imgTxt : 'Delete the image ' + imgTxt;
        let mainItem = item.principal ? '<span>' + principalTxt + '</span>' : '';
        li += '<li>';
        li += mainItem;
        li += '<div class="previewWrapper"><img src="' + item.url + '" alt="Imagen ' + imgTxt + '" class="previewImg"></div>';
        li += '<div class="buttonList">';
        li += '<button type="button" class="button" onclick="removeFile(' + index + ')" aria-label="' + deleteTxt + '"><i class="fas fa-trash"></i></button>';
        li += '<button type="button" class="button white" onclick="hazPrincipal(' + index + ')" aria-label="' + mainTxt + '"><i class="fas fa-star"></i></button>';
        li += '</div>';
        li += '</li>';
    } );
    $( '#fileList' ).html( li );
}
function removeFile( index ) {
    imageChange = true;
    selectedFiles.splice( index, 1 );
    let msg = idioma == 'ES' ? 'Imagen ' + (index + 1) + ' removida con éxito' : 'Image ' + (index + 1) + ' removed successfully';
    alerta( msg, 'success', false );
    cargaFileList();
}
function hazPrincipal( index ) {
    $.each( selectedFiles, function( key, item ) {
        item.principal = false;
    } );
    selectedFiles[index].principal = true;
    let msg = idioma == 'ES' ? 'Imagen ' + (index + 1) + ' marcada como principal con éxito' : 'Image ' + (index + 1) + ' marked as main successfully';
    alerta( msg, 'success', false );
    cargaFileList();
}
async function urlToFile( url ) {
	const response = await fetch( url );
	const blob = await response.blob();
	const filename = url.split( '/' ).pop();
	return new File( [ blob ], filename, { type: blob.type } );
}
async function reconstruirConFile( rutas ) {
	const gen = ++reconstruirConFileGen;
	const nextFiles = [];
	for ( const ruta of rutas ) {
		const file = await urlToFile( ruta.url );
		if ( gen !== reconstruirConFileGen ) {
			return;
		}
		nextFiles.push( {
			key: ruta.id,
			file: file,
			url: ruta.url,
			principal: !!ruta.primary
		} );
	}
	if ( gen !== reconstruirConFileGen ) {
		return;
	}
	selectedFiles = nextFiles;
	cargaFileList();
}
function lugarNuevo() {
    $( '#placeForm' )[0].reset();
    reiniciaLocaciones( 1 );
    $( '.id' ).val( 0 );
    selectedFiles = [];
	$( '#fileList' ).html( '' );
    navigator.geolocation.getCurrentPosition( cargaCoordenadas, function() { console.log( 'error obteniendo coordenadas' ); } );
    popup( 'placePopup', true );
}
function reiniciaLugar() {
    if ( archivoUsado != 'agregar-lugar.php' ) {
        popup( 'placePopup', false );
    } else {
        $( '#placeForm' )[0].reset();
        $( '.id' ).val( 0 );
		$( '#usuarioId' ).val( obtenSesion( 'usuarioId' ) );
        selectedFiles = [];
        $( '#fileList' ).html( '' );
        navigator.geolocation.getCurrentPosition( cargaCoordenadas, function() { console.log( 'error obteniendo coordenadas' ); } );
    }
}
function olvidePass() {
    let msg = idioma == 'ES' ? 'Ingresa el email con el que registraste tu cuenta' : 'Enter the email with which you registered your account';
    ingresaDato( msg, 'text', null, recuperaPass );
}
function recuperaPass( respuesta ) {
    if ( respuesta.isConfirmed && respuesta.value != '' ) {
        ajaxRequest( true, 'POST', { 'email': respuesta.value }, 'api/account/recupera', recuperada );
    }
}
function recuperada( respuesta ) {
    cargando( false );
    var datos =  JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
		let msg = idioma == 'ES' ? 'Hemos enviado el procedimiento de recuperación al email ingresado' : 'We have sent the recovery procedure to the entered email';
        alerta( msg, 'success', false );
    } else {
		let msg = idioma == 'ES' ? 'La cuenta ingresada no existe en nuestros registros' : 'The entered account does not exist in our records';
        alerta( msg, 'error', false );
    }
}
function abreImg( imgUrl ) {
	$( '#changeImage' ).attr( 'src', 'thumb?src=' + imgUrl + '&size=670x380&zoom=1' );
}
function slugCategory() {
    var slug  = limpiarTexto( $( '#name' ).val() );
    $( '#slug' ).val( slug );
}
function contactoMail() {
    var parametros = {
        'nombre': $( '#nombreContacto' ).val(),
        'email': $( '#emailContacto' ).val(),
        'asunto': $( '#subjectContacto' ).val(),
        'mensaje': $( '#mensajeContacto' ).val()
    };
    ajaxRequest( true, 'POST', parametros, 'api/comunidad/contacto', contactado );
}
function contactado( respuesta ) {
    cargando( false );
    var datos =  JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
		let msg = idioma == 'ES' ? 'Hemos enviado tu mensaje correctamente' : 'We have sent your message successfully';
        alerta( msg, 'success', false );
    } else {
		let msg = idioma == 'ES' ? 'Hubo un error al enviar tu mensaje' : 'There was an error sending your message';
        alerta( msg, 'error', false );
    }
}
function suscripbeForm() {
    ajaxRequest( true, 'POST', { 'email': $( '#emailNewsletter' ).val() }, 'api/comunidad/newsletter', suscrito );
}
function suscrito( respuesta ) {
    cargando( false );
    var datos =  JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
		let msg = idioma == 'ES' ? 'Hemos enviado registrado tu cuenta en nuestro sistema' : 'We have registered your account in our system.';
        alerta( msg, 'success', false );
    } else {
		let msg = idioma == 'ES' ? 'Hubo un error al enviar tu mensaje' : 'There was an error sending your message';
        alerta( msg, 'error', false );
    }
}

function lugarEvaluado( respuesta ) {
    cargando( false );
    var datos =  JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        let msg = idioma == 'ES' ? 'Comentario guardado con éxito' : 'Comment saved successfully';
        alerta( msg, 'success', true );
        $( '#valoracionForm' )[0].reset();
        $( '#valoracionForm .starPick' ).removeClass( 'is-active' );
    } else {
        let msg = idioma == 'ES' ? 'Hubo un problema al guardar tu comentario' : 'There was a problem saving your comment';
        alerta( msg, 'error', false );
    }
}
function cargaFeatures() {
    let lugarId = $( '#placeId' ).val();
    ajaxRequest( false, 'POST', { 'id': lugarId }, 'api/controller/list/places', featuresCargadas );
}
function featuresCargadas( respuesta ) {
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        console.log( datos.datos );
        $.each( datos.datos, function( key, value ) {
            var elementoHTML = $( '#' + key );
            if ( elementoHTML.length > 0 ) {
                if ( typeof elementoHTML[0] != 'undefined' ) {
                    var tipoElemento = elementoHTML[0].nodeName;
                    if ( tipoElemento == 'INPUT' ) {
                        var subTipo = elementoHTML[0].type;
                        if ( subTipo == 'checkbox' ) {
                            var checado = true;
                            if ( value == 'S' || value == 'N' ) {
                                checado = ( value == 'S' ) ? true : false;
                            } else {
                                checado = value;
                            }
                            elementoHTML.prop( 'checked', checado );
                            if ( checado ) {
                                elementoHTML.parent().addClass( 'checked' );
                            } else {
                                elementoHTML.parent().removeClass( 'checked' );
                            }
                        }
                    }
                }
            }
		} );
    }
}
function featureStart() {
    if ( checaSesion( 'usuarioId' ) ) {
        popup( 'caracteristicasLugarModal', true );
    } else {
        let msg = idioma == 'ES' ? 'Debes iniciar sesión para enviar una sugerencia de cambios de accesibilidad en el lugar' : 'You must log in to send an accessibility change suggestion in the place';
        alerta( msg, 'error', false );
    }
}
function guardaFeatures() {
    let parametros = {
        'lugarId': $( '#placeId' ).val(),
        'usuarioId': obtenSesion( 'usuarioId' ),
        'observaciones': $( '#observaciones' ).val()
    };
    let featuresList = [];
    $.each( $( '.featureCheck' ), function() {
        if ( $( this ).is( ':checked' ) ) {
            featuresList.push( { 'id': $( this ).attr( 'id' ), 'value': 'S' } );
        } else {
            featuresList.push( { 'id': $( this ).attr( 'id' ), 'value': 'N' } );
        }
    } );
    parametros[ 'features' ] = featuresList;
    ajaxRequest( true, 'POST', parametros, 'api/lugar/features', featuresGuardadas );
}
function featuresGuardadas( respuesta ) {
    cargando( false );
    var datos = JSON.parse( respuesta );
    if ( datos.status == 'Success' ) {
        let msg = idioma == 'ES' ? 'Sugerencia de cambios de accesibilidad en el lugar enviada con éxito' : 'Accessibility change suggestion sent successfully';
        alerta( msg, 'success', false );
        popup( 'caracteristicasLugarModal', false );
        cargaFeatures();
    } else {
        let msg = idioma == 'ES' ? 'Hubo un problema al enviar la sugerencia de cambios de accesibilidad en el lugar' : 'There was a problem sending the accessibility change suggestion in the place';
        alerta( msg, 'error', false );
    }
}